import type { App } from 'vue';
import * as Sentry from "@sentry/vue";
import router from './router';

export function configureSentry(app: App) {
    Sentry.init({
        app,
        dsn: "https://a5c29bfe06f5a954c23948f8f0843836@o4505676547883008.ingest.us.sentry.io/4505744477716480",
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            //Sentry.replayIntegration(),
        ],
        enabled: window.location.host.match(/^(.*)\.bookonthebrightside.com/) !== null,
        tracesSampleRate: 0.1,
        tracePropagationTargets: ["localhost", /^https:\/\/(.*)\.bookonthebrightside.com\/(rm4|RM4|gwt|brightside)/],
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.0,
    });
}